import { render } from "./SignupForm.vue?vue&type=template&id=790e6a9c"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Norbert\\webdev\\udemy-vue3\\chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__